import React, { useEffect, useState } from 'react';
import { InteractionStatus } from '@azure/msal-browser';
import logo from '../assets/img/wellink-white.svg';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useNavigate } from 'react-router-dom';
import { loginRequest } from '../auth-config';
import { useDispatch } from 'react-redux';
import { setPageTitle } from '../store/slices/pageTitleSlice';
import useLoggedInAccount from '../auth/LoggedInAccountInfo';

const Login: React.FC = () => {
    const { instance, inProgress, loggedInAccount } = useLoggedInAccount();
    const [validated, setValidated] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setPageTitle('Login | Spire360'));
        document.body.classList.add('no-aside');
        return () => {
            document.body.classList.remove('no-aside');
        };
    }, []);

    // Handle redirect response
    useEffect(() => {
        if (inProgress === InteractionStatus.None) {
            if (loggedInAccount) {
                instance.acquireTokenSilent({
                    ...loginRequest,
                    account: loggedInAccount,
                }).then((response) => {
                    localStorage.setItem('accessToken', response.accessToken);
                    console.log("Access Token: ", response.accessToken);
                    navigate('/home');
                }).catch((error) => {
                    console.error("Silent token acquisition failed", error);
                });
            } else {
                instance.handleRedirectPromise().then((response) => {
                    if (response) {
                        localStorage.setItem('accessToken', response.accessToken);
                        console.log("Access Token: ", response.accessToken);
                        navigate('/home');
                    }
                }).catch((error) => {
                    console.error("Redirect handling failed", error);
                });
            }
        }
    }, [inProgress, loggedInAccount, instance, navigate]);

    const handleLogin = () => {
        // Trigger the Azure AD login flow using a redirect
        // instance.loginRedirect(loginRequest);
    };

    return (
        <div className="row g-0">
            <div className="col-12 col-md-6 d-flex align-content-stretch">
                <div className="login__figure d-flex align-items-center justify-content-center">
                    <img src={logo} className="login__figure-logo img-fluid" alt="wellinks" />
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="login__wrap">
                    <Form className="login" noValidate validated={validated} onSubmit={handleLogin}>
                        <h1 className="h2">Sign In</h1>
                        <p className="fw-medium fs-15 text-dark">Please fill your login information below</p>
                        <div className="form-floating mb-3">
                            <input
                                type="email"
                                name="username"
                                className="form-control"
                                id="emailInput"
                                placeholder="Email address"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                            <label htmlFor="emailInput">Email address</label>
                        </div>
                        <div className="form-floating mb-3 input-password">
                            <input
                                type={showPassword ? "text" : "password"}
                                className="form-control"
                                id="passwordInput"
                                name="password"
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <label htmlFor="passwordInput">Password</label>
                            <a
                                className={`input-password__icon ${showPassword ? "is-active" : ""}`}
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setShowPassword(!showPassword);
                                }}
                            >
                                <span className="material-symbols-outlined fs-24 align-text-top">
                                    {showPassword ? "visibility_off" : "visibility"}
                                </span>
                            </a>
                        </div>
                        <div>
                            <div className="d-sm-flex align-items-center">
                                <div className="form-check form-switch flex-fill">
                                    <input className="form-check-input" type="checkbox" id="RememberCheck" />
                                    <label className="form-check-label ps-1" htmlFor="RememberCheck">
                                        <strong className="d-block fw-medium fs-14 text-dark">Remember me</strong>
                                        <span className="d-block fs-12 text-light">Save my login details for next time.</span>
                                    </label>
                                </div>
                                <div className="mt-4 mt-sm-0">
                                    <Button
                                        className="btn btn-primary text-white text-nowrap w-100"
                                        type="button"
                                        onClick={handleLogin}
                                    >
                                        Login Here
                                        <span className="material-symbols-outlined fs-16 align-text-top">
                                            arrow_forward_ios
                                        </span>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    );
};

export default Login;
